import request from './request/request'

const api = {
    install (Vue) {
        Vue.prototype.$api = api
    },
    request,
}

export default api